import type { AttachmentSkinAnalysisResponse } from "@/types/skin-analysis";

import { requestData } from "@/api/api-config";

export async function runAttachmentSkinAnalysis(
  attachmentId: string,
): Promise<AttachmentSkinAnalysisResponse | null> {
  return await requestData<AttachmentSkinAnalysisResponse>(
    `attachments/${attachmentId}/skin-analysis`,
    "post",
    {},
    false,
    60000,
  );
}

export async function getAttachmentSkinAnalysis(
  attachmentId: string,
): Promise<AttachmentSkinAnalysisResponse | null> {
  return await requestData<AttachmentSkinAnalysisResponse>(
    `attachments/${attachmentId}/skin-analysis`,
    "get",
    {},
    false,
  );
}
